var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config.loginNoticeShowMode == "1" && _vm.config.loginNoticeContent
    ? _c("div", { staticClass: "notice-announcement" }, [
        _c("div", { staticClass: "notice-announcement-title" }, [
          _c(
            "div",
            {
              staticClass: "laba-wrap",
              style: { background: "#" + _vm.config.schemeColor }
            },
            [
              _c("img", {
                staticClass: "notice-img",
                attrs: { src: require("@/assets/img/laba.svg"), alt: "" }
              })
            ]
          ),
          _c("div", [
            _vm._v(_vm._s(_vm.i18n["screen.loginnotice.title"] || "登录公告"))
          ])
        ]),
        _c(
          "div",
          { staticClass: "notice-announcement-content" },
          [
            _c(
              "el-scrollbar",
              { staticStyle: { height: "100%", "margin-top": "16px" } },
              [
                _c(
                  "div",
                  { staticClass: "content" },
                  _vm._l(_vm.loginNoticeContent, function(item, index) {
                    return _c("div", { key: index }, [_vm._v(_vm._s(item))])
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }